import React from 'react';
import loaderImge from '../assets/images/Loader.gif';

const Loader = () => {
	return (
		<div className='gm_common_loader'>
			<img src={loaderImge} alt='Loading...' />
		</div>
	);
};

export default Loader;
